import { grey, warning } from "../palette";

export default {
  styleOverrides: {
    root: {
      color: grey[400],
      "&:hover": {
        backgroundColor: grey[50],
        color: grey[900],
      },
    },
    colorWarning: {
      color: grey[400],
      "&:hover": {
        backgroundColor: warning.light,
        color: warning.dark,
      },
    },
  },
};
